module.exports = __webpack_public_path__ + "static/media/youtube-logo.14a5e6cb.png";